import {Column, ColumnStore} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";
import {defaultCellRenderer, defaultGroupRenderer} from "../../other/utils/utils.jsx";
import { NO_VALUE } from "../../other/constants/OtherKeys.jsx";

export default class PhoneNumberColumn extends Column {
  static get $name() {
    return "PhoneNumberColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnPhoneNumber;
  }

  static get defaults() {
    return {
      text: "Phone",
      editor: {
        type: WIDGET_KEYS.fieldPhone
      },
      cellCls: "swivu-phone-column",
      flex: 1,
    }
  }

  swivuGetFormattedPhone(phoneNumber) {
    if (phoneNumber) {
      phoneNumber = window.intlTelInputUtils.formatNumber(phoneNumber, null, window.intlTelInputUtils.numberFormat.INTERNATIONAL);
    }
    return phoneNumber;
  }

  groupRenderer({ groupRowFor: value, count, ...rest }) {
    if (value && value !== NO_VALUE) {
      return defaultGroupRenderer({ count, groupRowFor: this.swivuGetFormattedPhone(value), ...rest });
    }
    return defaultGroupRenderer({ count, groupRowFor: value, ...rest });
  }

  defaultRenderer({ record }) {
    return defaultCellRenderer({ value: this.swivuGetFormattedPhone(record.get(this.field)) });
  }
}

ColumnStore.registerColumnType(PhoneNumberColumn);
